import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_all, fetch_all_with_count, fetch_one } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
// import { currentPracticeAtom } from '../../../../lib/practice';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import {
  Divider,
  Grid,
  Paper,
} from '@mui/material';

import {
  Button,
  Typography
} from '../../../../components/v2/styled';

import { User } from '../../../../models/User';
import { SnackCopied } from '../../../../components/v2/snacks/Copied';

// const { DateTime } = require("luxon");

type Props = {
  object: User;
  mutationCustomAction: any;
  passResetLink?: string;
  passResetEmail?: string;
}

export const CoachUserWidgetsAccountManagement: FunctionComponent<Props> = ({
  object,
  mutationCustomAction,
  passResetLink, passResetEmail
}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const params = useParams();
  // const queryClient = useQueryClient();
  // const { state } = useLocation();
  // const [searchParams, setSearchParams] = useSearchParams();
  
  const [copyOpen, setCopyOpen] = useState<boolean>(false);












  return <Paper sx={{padding: 2, marginTop: 1}}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h5" html>{t("coach.submenu.detail.account_management")}</Typography>
        <Divider />
      </Grid>
      {/* Titles are no longer shown in this widget — commented (not deleted)
          for easy re-enable, same as the actions widget:
      <Grid item xs={12} sx={{marginTop: 1}}>
        <Typography variant="subtitle2">{t("coach.submenu.detail.password_reset")}</Typography>
      </Grid> */}
      {!passResetLink && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Button
          id="passreset"
          onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'user',
                class_action: 'custom_api_inquire_new_password',
                id: object.id
              },
              pass: true
            });
          }}
          label={t("coach.general.buttons.request_pass_reset_link")}
          sx={{marginTop: 1}}
        />
      </Grid>}
      {!!passResetLink && <Grid item xs={12}>
        <Typography sx={{fontSize: '0.9rem'}} html>{t("coach.submenu.detail.password_reset_explanation")}</Typography>
        <Typography sx={{fontSize: '0.8rem', paddingLeft: 2}}>{passResetEmail} <ContentCopyIcon
          sx={{cursor: 'pointer', scale: '0.7', marginRight: 1, marginBottom: -1, color: theme.palette.primary.main}}
          onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(passResetEmail || '');
            setCopyOpen(true);
          }}
        /></Typography>
        <Typography sx={{fontSize: '0.9rem', marginTop: 1}} html>{t("coach.submenu.detail.password_reset_explanation_link")}</Typography>
        <Typography sx={{fontSize: '0.8rem', wordBreak: 'break-all', paddingLeft: 2}}>{passResetLink} <ContentCopyIcon
          sx={{cursor: 'pointer', scale: '0.7', marginRight: 1, marginBottom: -1, color: theme.palette.primary.main}}
          onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(passResetLink || '');
            setCopyOpen(true);
          }}
        /></Typography>
      </Grid>}
      {/* Titles are no longer shown in this widget — commented (not deleted)
          for easy re-enable, same as the actions widget:
      {object.mfa_status === 1 && <Grid item xs={12} sx={{marginTop: 1}}>
        <Typography variant="subtitle2">{t("coach.personal_settings.security.two_factor.title")}</Typography>
        <Typography variant="caption">{t("coach.personal_settings.security.two_factor.user_detail_line")}</Typography>
      </Grid>} */}
      {object.mfa_status === 1 && <Grid item xs={12} sx={{marginTop: 1}}>
        <Button
          id="2fa_disable"
          secondary
          destroyBtn
          onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'user',
                class_action: 'custom_api_mfa_actions',
                id: object?.id,
                mfa_action: 'disable'
              },
              mfa: true
            });
          }}
          label={t("coach.general.buttons.disable_mfa")}
          sx={{marginTop: 1}}
        />
      </Grid>}
    </Grid>
    
    <SnackCopied open={copyOpen} setOpen={setCopyOpen} />
  </Paper>;
}
